import { useSecurityDepositField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const SecurityDepositRow = () => {
    const { label, inputProps } = useSecurityDepositField({ tab: DealTabs.SUMMARY });
    const inputId = useScenarioCellId('securityDeposit');

    return (
        <ScenarioRow rowKey="securityDeposit" label={label} inputId={inputId}>
            <NumericInput {...inputProps} id={inputId} displayLabel={false} />
        </ScenarioRow>
    );
};
